import { render, staticRenderFns } from "./LuxinWidget.vue?vue&type=template&id=03ecb829"
import script from "./LuxinWidget.vue?vue&type=script&lang=js"
export * from "./LuxinWidget.vue?vue&type=script&lang=js"
import style0 from "./LuxinWidget.vue?vue&type=style&index=0&id=03ecb829&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports